'use client';

import { useMemo, useState } from 'react';
import { EditModal } from '@/components/ui/edit-modal';
import { BasicInfoDescriptionField } from '@/features/tournament-wizard/blocks';
import { DESCRIPTION_TEMPLATE } from '@/features/tournament-wizard/sports/shared/templates/basicInfoTemplates';
import {
  resolveDescriptionReglamento,
  type ReglamentoSource,
} from '@/utils/tournament-reglamento';

interface EditDescriptionModalProps {
  isOpen: boolean;
  onClose: () => void;
  currentDescription: string;
  onSave: (newDescription: string) => Promise<boolean>;
  isLoading: boolean;
  /** The saved config, so the template's reglamento comes out already filled in. */
  reglamentoSource: ReglamentoSource;
}

export function EditDescriptionModal({
  isOpen,
  onClose,
  currentDescription,
  onSave,
  isLoading,
  reglamentoSource,
}: EditDescriptionModalProps) {
  const [description, setDescription] = useState(currentDescription);

  const template = useMemo(
    () => resolveDescriptionReglamento(DESCRIPTION_TEMPLATE, reglamentoSource),
    [reglamentoSource],
  );

  const handleSave = async () => {
    // A placeholder pasted from a wizard draft would otherwise be published as is.
    await onSave(resolveDescriptionReglamento(description, reglamentoSource));
  };

  return (
    <EditModal
      isOpen={isOpen}
      onClose={onClose}
      title="Editar Descripción"
      onSave={handleSave}
      isLoading={isLoading}
    >
      <div className="py-4">
        <BasicInfoDescriptionField
          value={description}
          onChange={setDescription}
          wrapInCard={false}
          template={template}
        />
      </div>
    </EditModal>
  );
}
